import { deviceType } from "@tm/isomorphic-utils";
import styled from "styled-components";
import { LandingButtonTertiaryStyle } from "../LandingButton/LandingButton.style";
import { SpanTagStyle } from "../TextStyles/TextStyles.style";

export const ToastStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  background: #4a4a4a;
  box-shadow: 0px 3px 30px rgba(0, 0, 0, 0.16);
  border-radius: 12px;
  width: 436px;
  position: fixed;
  bottom: 30px;
  right: 30px;
  gap: 8px;
  ${SpanTagStyle} {
    flex-shrink: 0;
  }
  ${LandingButtonTertiaryStyle} {
    width: 127px;
  }
  @media ${deviceType.mobile} {
    width: calc(100% - 32px);
    padding: 8px 16px;
    right: 16px;
    left: 16px;
  }
`;

export const CloseIconWrap = styled.div`
  width: 28px;
  height: 28px;
  cursor: pointer;
`;

export const ToastIcon = styled.div`
  display: flex;
  flex-shrink: 0;
`;
